import React from "react";
import { LOGO_URL, CLINIC } from "@/lib/constants";

export default function Logo({ className = "h-9", onDark = true, showPill = true }) {
  const img = (
    <img
      src={LOGO_URL}
      alt={`${CLINIC.name} - ${CLINIC.tagline}`}
      className={className}
      data-testid="cardiobaus-logo"
    />
  );
  if (onDark && showPill) {
    return <div className="bg-white rounded-xl px-3 py-1.5 inline-flex items-center shadow-sm">{img}</div>;
  }
  return img;
}
